import { apiClient } from '../lib/api';
import {
	ApiResponseSchema,
	SmtpPublicSchema,
	SmtpTestResultSchema,
	type SmtpPublic,
	type SmtpTest,
	type SmtpUpdate,
} from '../schemas';

const BASE = '/admin/smtp';

export const smtpApi = {
	/** `null` until an admin has saved a configuration. */
	async get(): Promise<SmtpPublic | null> {
		const res = await apiClient.get<unknown>(BASE);
		return ApiResponseSchema(SmtpPublicSchema.nullish()).parse(res.data).data ?? null;
	},
	async update(body: SmtpUpdate): Promise<SmtpPublic> {
		const res = await apiClient.put<unknown>(BASE, body);
		return ApiResponseSchema(SmtpPublicSchema).parse(res.data).data;
	},
	async test(body: SmtpTest): Promise<void> {
		const res = await apiClient.post<unknown>(`${BASE}/test`, body);
		ApiResponseSchema(SmtpTestResultSchema).parse(res.data);
	},
};
